<script setup lang="ts">
import { useRoute } from 'vue-router';
import AppBanner from '~/components/AppBanner.vue';
import AppHeader from '~/components/AppHeader.vue';
import AppRail from '~/components/AppRail.vue';
import ShareModal from '~/components/ShareModal.vue';
import { useShareModalStore } from '~/stores/share-modal-store';

const route = useRoute();
// Used on the dashboard and project pages
const shareModalStore = useShareModalStore();
</script>

<template>
  <ShareModal
    v-if="shareModalStore.show && shareModalStore.project"
    v-model="shareModalStore.show"
    :code-url="shareModalStore.codeUrlToCopy"
    :site-url="shareModalStore.siteUrlToCopy"
    :project-id="shareModalStore.projectId"
    @close="shareModalStore.close"
  />

  <div class="flex h-screen flex-nowrap">
    <AppRail />

    <div class="flex h-screen flex-auto flex-col items-stretch overflow-auto">
      <AppBanner />
      <AppHeader v-if="route.meta.hideLayoutHeader !== true" class="px-4" />
      <RouterView />
    </div>
  </div>
</template>
